import { Outlet, ScrollRestoration } from 'react-router-dom';

import { AnnouncementBar } from './AnnouncementBar';
import { PublicFooter } from './PublicFooter';
import { PublicHeader } from './PublicHeader';

export function PublicLayout() {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <AnnouncementBar />
      <PublicHeader />
      <main id="main-content" tabIndex={-1}>
        <Outlet />
      </main>
      <PublicFooter />
      <ScrollRestoration />
    </div>
  );
}
